export default __webpack_public_path__ + "static/media/animals.6170cdca.jpg";